var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadFace(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 108,
    viewBox: "0 0 101 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 53.9828,
    rx: 50.5,
    ry: 53.9828,
    fill: "#FFD3D3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.3924,
    cy: 44.8405,
    rx: 7.83621,
    ry: 8.27155,
    fill: "#DD0B0C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.043,
    cy: 44.8405,
    rx: 7.83621,
    ry: 8.27155,
    fill: "#DD0B0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3923 78.3621C34.3923 78.3621 38.5451 69.6552 51.1293 69.6552C63.7135 69.6552 66.6079 78.3621 66.6079 78.3621",
    stroke: "#DD0B0C",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/assets/sad-face.svg";
export { ForwardRef as ReactComponent };